/* ==========================================================================
   Stuga Juice JS — Scroll reveals, sticky ATC, back-to-top
   Zero dependencies, mobile-first
   ========================================================================== */

(function() {
  'use strict';

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // =======================================================================
  // SCROLL REVEAL
  // =======================================================================
  function initScrollReveal() {
    if (reducedMotion) return;

    var selectors = [
      '.card-wrapper',

      '.blog-articles__article',
      '.rich-text',
      '.image-with-text',
      '.multicolumn .column',
      '.collage__item'
    ];

    var elements = document.querySelectorAll(selectors.join(','));
    if (!elements.length) return;

    // Elements matching these selectors get a clip-path reveal instead of fade
    var clipEls = document.querySelectorAll('.collage__item');
    var clipSet = new Set(clipEls);

    elements.forEach(function(el) {
      var rect = el.getBoundingClientRect();
      // Don't animate elements already in viewport on load
      if (rect.top < window.innerHeight * 0.85 && rect.top > 0) return;

      el.classList.add(clipSet.has(el) ? 'stuga-reveal--clip' : 'stuga-reveal');

      // Stagger delay for grid siblings
      var parent = el.parentElement;
      if (parent) {
        var siblings = parent.querySelectorAll(':scope > ' + el.tagName.toLowerCase());
        var index = Array.prototype.indexOf.call(siblings, el);
        if (index > 0 && index <= 5) {
          el.setAttribute('data-delay', index);
        }
      }
    });

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.stuga-reveal, .stuga-reveal--clip').forEach(function(el) {
      observer.observe(el);
    });
  }

  // =======================================================================
  // STICKY ADD-TO-CART BAR (mobile product pages)
  // =======================================================================
  function initStickyATC() {
    // Only on product pages, only on mobile
    var productForm = document.querySelector('product-form .product-form__submit');
    if (!productForm) return;
    if (window.innerWidth >= 990) return;

    // Get product info from the page
    var titleEl = document.querySelector('.product__title');
    var priceEl = document.querySelector('.product__info-wrapper .price-item--regular, .product__info-wrapper .price-item--sale');
    if (!titleEl) return;

    var title = titleEl.textContent.trim();
    var price = priceEl ? priceEl.textContent.trim() : '';

    // Build sticky bar
    var bar = document.createElement('div');
    bar.className = 'stuga-sticky-atc';
    bar.style.display = 'block';
    bar.innerHTML =
      '<div class="stuga-sticky-atc__inner">' +
        '<div class="stuga-sticky-atc__info">' +
          '<div class="stuga-sticky-atc__title">' + escapeHtml(title) + '</div>' +
          (price ? '<div class="stuga-sticky-atc__price">' + escapeHtml(price) + '</div>' : '') +
        '</div>' +
        '<button class="stuga-sticky-atc__btn" type="button">' +
          (productForm.disabled ? 'Sold out' : 'Add to Cart') +
        '</button>' +
      '</div>';

    document.body.appendChild(bar);

    var btn = bar.querySelector('.stuga-sticky-atc__btn');
    if (productForm.disabled) {
      btn.disabled = true;
    }

    // Clicking sticky ATC triggers the real form submit
    btn.addEventListener('click', function() {
      productForm.click();
      // Brief visual feedback
      btn.textContent = 'Adding...';
      setTimeout(function() {
        btn.textContent = 'Add to Cart';
      }, 1200);
    });

    // Show/hide based on scroll position relative to real ATC button
    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          bar.classList.remove('is-visible');
        } else {
          // Only show when scrolled PAST the button (it's above viewport)
          if (entry.boundingClientRect.top < 0) {
            bar.classList.add('is-visible');
          } else {
            bar.classList.remove('is-visible');
          }
        }
      });
    }, { threshold: 0 });

    observer.observe(productForm);

    // Update price when variant changes
    var priceObserver = new MutationObserver(function() {
      var newPrice = document.querySelector('.product__info-wrapper .price-item--regular, .product__info-wrapper .price-item--sale');
      if (newPrice) {
        var priceDisplay = bar.querySelector('.stuga-sticky-atc__price');
        if (priceDisplay) priceDisplay.textContent = newPrice.textContent.trim();
      }
      // Update sold-out state
      var currentBtn = document.querySelector('product-form .product-form__submit');
      if (currentBtn) {
        btn.disabled = currentBtn.disabled;
        btn.textContent = currentBtn.disabled ? 'Sold out' : 'Add to Cart';
      }
    });

    var priceWrapper = document.querySelector('.product__info-wrapper .price');
    if (priceWrapper) {
      priceObserver.observe(priceWrapper, { childList: true, subtree: true, characterData: true });
    }
  }

  // =======================================================================
  // SCROLL PROGRESS BAR
  // =======================================================================
  function initScrollProgress() {
    var bar = document.createElement('div');
    bar.className = 'stuga-scroll-progress';
    bar.style.cssText = 'position:fixed;top:0;left:0;width:0%;height:3px;background-color:#626e62;z-index:9999;transition:none;pointer-events:none;opacity:0.85;';
    document.body.appendChild(bar);

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var scrollTop = window.scrollY;
          var docHeight = document.documentElement.scrollHeight - window.innerHeight;
          if (docHeight > 0) {
            bar.style.width = (scrollTop / docHeight * 100) + '%';
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // =======================================================================
  // BACK TO TOP BUTTON
  // =======================================================================
  function initBackToTop() {
    var btn = document.createElement('button');
    btn.className = 'stuga-back-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = '<svg viewBox="0 0 24 24"><polyline points="18 15 12 9 6 15"></polyline></svg>';
    document.body.appendChild(btn);

    btn.addEventListener('click', function() {
      window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
    });

    // Show after scrolling 60% of viewport height
    var threshold = window.innerHeight * 0.6;
    var visible = false;
    var ticking = false;

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          var shouldShow = window.scrollY > threshold;
          if (shouldShow !== visible) {
            visible = shouldShow;
            btn.classList.toggle('is-visible', visible);
          }
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  // =======================================================================
  // LAZY IMAGE FADE-IN
  // =======================================================================
  function initLazyImageFade() {
    if (reducedMotion) return;

    var images = document.querySelectorAll('img[loading="lazy"]');
    images.forEach(function(img) {
      if (img.complete) return;
      img.style.opacity = '0';
      img.style.transition = 'opacity 0.4s ease';
      img.addEventListener('load', function() {
        img.style.opacity = '';
      }, { once: true });
    });
  }

  // =======================================================================
  // UTILITY
  // =======================================================================
  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  // =======================================================================
  // INIT
  // =======================================================================
  function init() {
    initScrollReveal();
    initLazyImageFade();
    initStickyATC();
    initBackToTop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section re-render (theme editor)
  document.addEventListener('shopify:section:load', function() {
    initScrollReveal();
    initLazyImageFade();
  });
})();
